import { useFormContext } from "react-hook-form";
import { SignInParams, useAuth } from "~/presentation/core/contexts/AuthContext";
import { Checkbox, PasswordInput, TextInput } from "~/components/Input";
import { FieldLabel, FormControl } from "~/components/FormControl";
import { SvgMail } from "~/components/Icon/icons";
import { Button } from "~/components/Button";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";
import { Link } from "~/components/Link";
import { Alert } from "~/components/Alert";

export interface SignInContainerProps {
  showAttempts: boolean;
}

export const SignInForm = ({ showAttempts }: SignInContainerProps) => {
  const { qrCodeUrl, attempts } = useAuth();
  const MAX_ATTEMPTS = 5; //4 pois a contagem começa em 0



  const { control, watch, setValue } = useFormContext<SignInParams>();
  const { email, password } = watch();
  const hasCredentialLogin = !!email && !!password;

  const showAttemptMessage = showAttempts && !qrCodeUrl && attempts >= 3 && attempts <= MAX_ATTEMPTS ;

  return (
    <>
      <Flex direction="column" gap="5">
        <FormControl name="email" control={control}>
          <FieldLabel>E-mail</FieldLabel>
          <TextInput
            leftIcon={SvgMail}
            autoComplete="email"
            placeholder="Insira seu e-mail"
            onChange={(e) => {
              setValue("email", e.target.value);
            }}
          />
        </FormControl>

        <Flex direction="column" gap="4">
          <FormControl name="password" control={control}>
            <FieldLabel>Senha</FieldLabel>
            <PasswordInput
              autoComplete="current-password"
              placeholder="Insira sua senha"
              onChange={(e) => {
                setValue("password", e.target.value);
              }}
            />
          </FormControl>

          <Flex align="center" justify="center" gap="4" css={{ mt: "$2" }}>
            <Link
              to="/redefinir-senha"
              css={{
                fontSize: "$sm",
                color: "$primary-base",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Esqueci minha senha
            </Link>
          </Flex>
        </Flex>
      </Flex>

      {showAttemptMessage && (
        <Alert
          variant="warning"
          size="sm"
          css={{ width: "fit-content", margin: "0 auto", p: "10px" }}
        >
          <Flex
            direction="column"
            align="center"
            gap="2"
            css={{ width: "100%", textAlign: "center" }}
          >
            <Text
              size="3"
              variant="dark"
              css={{
                color: "$warning-dark",
                fontWeight: "bold",
              }}
            >
              Você realizou {attempts} tentativas de login!
            </Text>
            <Text
              size="3"
              variant="dark"
              css={{
                color: "$warning-dark",
                letterSpacing: "0.5px",
                fontWeight: "initial",
                padding: "0 $2",
              }}
            >
              Após a 4ª tentativa, seu usuário será bloqueado. Para evitar o bloqueio {""}
              <Link
                to="/redefinir-senha"
                css={{
                  fontWeight: "600",
                  fontSize: "$sm",
                  color: "$primary-base",
                  "&:hover": { textDecoration: "underline", color: "$primary-dark" },
                }}
              >
                redefina sua senha agora.
              </Link>
            </Text>
          </Flex>
        </Alert>
      )}

      <Button type="submit" fullWidth disabled={!hasCredentialLogin}>
        Entrar
      </Button>
    </>
  );
};
